<template>
    <vSelect
        class="dropdown form-control"
        :id="schema.id"
        v-model="value"
        :placeholder="schema.placeholder"
        :options="typeof schema.values === 'function' ? schema.values(model) : schema.values"
        :reduce="option => option.value"
        label="name">
    </vSelect>
</template>

<script>
    import vSelect from "vue-select";
    import "vue-select/src/scss/vue-select.scss";
    import { abstractField } from "vue-form-generator";

    export default {

        mixins: [ abstractField ],

        components: {vSelect},

        data() {
            return {

            }
        }

    };
</script>

<style lang="scss" scoped>
    .dropdown {
        width: 100%;
        margin: 0px;
        padding-left: 0px;
    }

    .form-group.error .dropdown {
        border: 1px solid red;
        background-color: rgba(255,0,0,.15);
    }

    ::v-deep {

        .vs__dropdown-toggle {
            border: none;
            height: 100%;
            padding: 0px;
        }

        .vs__selected-options {
            padding: 0px;
            overflow-x: hidden;
        }

        .vs__clear {
            display: none !important;
        }

        .vs__actions {
            padding: 0px;
        }

        .vs__search {
            margin: 0px;
            border: none !important;
            background-color: transparent !important;
        }

        .vs__selected {
            border: none;
            margin: 0px;
            padding: 0px;
            white-space: nowrap;
        }

        .vs__dropdown-menu {
            width: 101%;
            min-width: 0px;
            border: 2px solid rgba(60, 60, 60, 0.26);
        }

    }

    button {
        display: none;
    }
</style>